var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef5323;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 12,
    height: 12,
    rx: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12 5.25 8.62 5.25 7.5 6.9 4.5 2.4 2.63 5.25 0 5.25 0 6.75 3.38 6.75 4.5 5.1 7.5 9.6 9.37 6.75 12 6.75 12 5.25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskProfile);
export default __webpack_public_path__ + "static/media/risk_profile.2c04ad2b8915c4fb301d8d8a4c2e926a.svg";
export { ForwardRef as ReactComponent };